export const POST_ACTION_SUBSCRIBE = 'subscribe';
export const POST_ACTION_EDIT = 'edit';
export const POST_ACTION_SHARE = 'share';
export const POST_ACTION_PRINT = 'print';
export const POST_ACTION_PIN = 'pin';
export const POST_ACTION_TOGGLE_COMMENTS = 'toggle-comments';
export const POST_ACTION_REPORT = 'report';
export const POST_ACTION_DELETE = 'delete';
export const POST_ACTION_DUPLICATE = 'duplicate';
export const POST_ACTION_REVERT_TO_DRAFT = 'revert-to-draft';
export const POST_ACTION_REJECT_POST_IN_MODERATION = 'reject-post-in-moderation';
export const POST_ACTION_REVERT_POST_IN_MODERATION = 'revert-post-in-moderation';
export const POST_ACTION_TRANSLATE = 'translate';
export const POST_ACTION_CHANGE_LANGUAGE = 'change-language';
export const POST_ACTIONS = [
    POST_ACTION_SUBSCRIBE,
    POST_ACTION_EDIT,
    POST_ACTION_SHARE,
    POST_ACTION_PRINT,
    POST_ACTION_PIN,
    POST_ACTION_REVERT_TO_DRAFT,
    POST_ACTION_TOGGLE_COMMENTS,
    POST_ACTION_REPORT,
    POST_ACTION_DELETE,
    POST_ACTION_TRANSLATE,
    POST_ACTION_CHANGE_LANGUAGE,
];
//# sourceMappingURL=post-actions.js.map